// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__tvW2c","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1TJOT"};